import React from 'react'

import classNames from 'classnames'

import { Box, BoxProps } from 'ui/components/Box'
import { ScrollArea } from 'ui/components/ScrollArea'

import { useFileUploadFileListState } from './hooks/useFileUploadFileListState'
import { FileUploadFileListItem } from './FileUploadFileListItem'

import { FileUploadFileListScrollAreaStyle } from './FileUpload.css'

type FileUploadFileListProps = BoxProps & {}

export const FileUploadFileList: React.FC<FileUploadFileListProps> = ({ className, ...props }) => {
    const { listId, shouldShow, items } = useFileUploadFileListState()

    if (!shouldShow) return null

    return (
        <ScrollArea
            direction="vertical"
            type="always"
            width="full"
            className={classNames(FileUploadFileListScrollAreaStyle, className)}
            {...props}
        >
            <Box
                role="list"
                id={listId}
                aria-orientation="vertical"
                data-state="active"
                flex
                column
                gap="m"
            >
                {items.map((item, idx) => (
                    <FileUploadFileListItem
                        key={idx}
                        value={item}
                        fileIndex={idx}
                        fileCount={items.length}
                    />
                ))}
            </Box>
        </ScrollArea>
    )
}
